/**
 * Product Appointment Vue Component
 * ------------------------------------------------------------------------------
 * Template in sections/product__package.liquid
 *
 */
import Cookies from 'js-cookie'
import axios from 'axios'

import ProductItem from '@/js/components/product-item.js'
import VueCollapsible from '@/js/components/vue-collapsible.vue'
import Country from '@/js/templates/country.json'

import { storefrontRequestConfig, STOREFRONT_URL } from '@/js/utils/api'
import { transformStoreLocation, variantStockInLocationRequest } from '@/js/utils/data'

export default {
  components: {
    ProductItem,
    VueCollapsible,
    Country
  },
  mounted () {
    const vm = this

    // TODO: Use mutation observer
    // Opens the appointment modal in the product package description link
    setTimeout(() => {
      const appointmentLink = document.querySelector('div.appointment-description > p > a')
      if (appointmentLink && appointmentLink.hash === '#AppointmentModal') {
        if (appointmentLink.target === '_blank') {
          appointmentLink.removeAttribute('target')
        }

        appointmentLink.addEventListener('click', () => {
          this.toggleAppointmentForm('#AppointmentModal')
        })
      }
    }, 2000)

    this.fetchCountries()

    setTimeout(function () { vm.selectScript() }, 2000)
    document.addEventListener('click', this.closeAllSelect)
  },

  data () {
    return {
      showAppointmentForm: false,
      countries: [],
      states: [],
      selectedCountry: null,
      selectedState: null,
      showProductPackage: false
    }
  },

  props: {
    emptyField: {
      type: String,
      required: true
    },
    invalidEmail: {
      type: String,
      required: true
    },
    invalidPhone: {
      type: String,
      required: true
    },
    productId: {
      type: String,
      required: true
    },
    clientId: {
      type: String,
      required: true
    },
    formId: {
      type: String,
      required: true
    },
    messageAccessCheckId: {
      type: String,
      required: true
    }
  },

  computed: {
    currentState () {
      return Cookies.get('state') || 'NSW' // used to filter products based on the available inventory in a location
    }
  },

  created () {
    // check if product has stock on the specified location
    const data = variantStockInLocationRequest(this.productId)
    axios.post(STOREFRONT_URL, data, storefrontRequestConfig).then(({ data }) => {
      const product = transformStoreLocation(data.data)

      // check if the current state value is ACT
      if (this.currentState === 'ACT') {
        // If the state is ACT, include products from both ACT and NSW warehouses
        if (product && (product.variants.available_on?.includes(this.currentState) || product.variants.available_on?.includes('NSW'))) {
          this.showProductPackage = true
        }
      } else {
        // check the state value (from the Cookie) and match if the selected state has an available inventory in the product
        if (product && product.variants.available_on?.includes(this.currentState)) {
          this.showProductPackage = true
        }
      }
    }).catch((error) => {
      console.log('Location check error:', error)
      throw error
    })
  },

  methods: {
    selectScript () {
      const vm = this // Store the Vue instance context
      const changeCountryBound = this.changeCountry.bind(vm) // Bind the changeCountry method to the Vue instance
      let i, j, selectElement, selectedItemDiv, optionList, optionItem
      const selectContainer = document.getElementsByClassName('floating-input')

      for (i = 0; i < selectContainer.length; i++) {
        selectElement = selectContainer[i].querySelector('select')

        if (selectElement) {
          selectedItemDiv = document.createElement('DIV')
          selectedItemDiv.setAttribute('class', 'select-selected')
          selectedItemDiv.innerHTML = selectElement.options[selectElement.selectedIndex].innerHTML
          selectContainer[i].appendChild(selectedItemDiv)
          /* For each element, create a new DIV that will contain the option list: */
          optionList = document.createElement('DIV')
          optionList.setAttribute('class', 'select-items select-hide')

          for (j = 1; j < selectElement.length; j++) {
            /* For each option in the original select element, create a new DIV that will act as an option item: */

            optionItem = document.createElement('DIV')
            optionItem.innerHTML = selectElement.options[j].innerHTML

            optionItem.addEventListener('click', function (e) {
              /* When an item is clicked, update the original select box, and the selected item: */
              let y, i, k, yl
              const s = this.parentNode.parentNode.getElementsByTagName('select')[0]
              const sl = s.length
              const h = this.parentNode.previousSibling

              for (i = 0; i < sl; i++) {
                if (s.options[i].innerHTML === this.innerHTML) {
                  s.selectedIndex = i
                  h.innerHTML = this.innerHTML
                  y = this.parentNode.getElementsByClassName('same-as-selected')
                  yl = y.length

                  for (k = 0; k < yl; k++) {
                    y[k].removeAttribute('class')
                  }
                  this.setAttribute('class', 'same-as-selected')

                  if (s.id === 'appointmentCountry') {
                    const event = { target: { value: s.value } }
                    changeCountryBound(event)
                  }

                  break
                }
              }
              h.click()
            })
            optionList.appendChild(optionItem)
          }
          selectContainer[i].appendChild(optionList)
          selectedItemDiv.addEventListener('click', function (event) {
            /* When the select box is clicked, close any other select boxes, and open/close the current select box: */
            event.stopPropagation()
            // this.this.closeAllSelect(this)
            const arrNo = []
            const selectedItems = document.getElementsByClassName('select-items')
            const selectedItem = document.getElementsByClassName('select-selected')
            let i

            for (i = 0; i < selectedItem.length; i++) {
              if (this === selectedItem[i]) {
                arrNo.push(i)
              } else {
                selectedItem[i].classList.remove('select-arrow-active')
              }
            }
            for (i = 0; i < selectedItems.length; i++) {
              if (arrNo.indexOf(i)) {
                selectedItems[i].classList.add('select-hide')
              }
            }
            this.nextSibling.classList.toggle('select-hide')
            this.classList.toggle('select-arrow-active')
          })
        }
      }
    },
    closeAllSelect (element) {
      /* A function that will close all select boxes in the document,
      except the current select box: */
      const arrNo = []
      const selectedItems = document.getElementsByClassName('select-items')
      const selectedItem = document.getElementsByClassName('select-selected')
      let i

      for (i = 0; i < selectedItem.length; i++) {
        if (element === selectedItem[i]) {
          arrNo.push(i)
        } else {
          selectedItem[i].classList.remove('select-arrow-active')
        }
      }
      for (i = 0; i < selectedItems.length; i++) {
        if (arrNo.indexOf(i)) {
          selectedItems[i].classList.add('select-hide')
        }
      }
    },
    validateAppointment () {
      if (this.isValid('ProductAppointmentForm')) {
        this.submitForm(document.ProductAppointmentForm, 'ProductAppointmentForm')
      }
    },
    toggleAppointmentForm (appointmentLink = '') {
      if (appointmentLink !== '#AppointmentModal') {
        window.open(appointmentLink, '_blank')
      }

      this.showAppointmentForm = !this.showAppointmentForm
      const targetElement = document.querySelector('div.appointment__popup')

      if (this.showAppointmentForm) {
        targetElement.classList.add('flex')
      } else {
        targetElement.classList.remove('flex')
      }
    },
    fetchCountries () {
      this.countries = Country.map(country => country)
      this.selectedCountry = this.countries[10].value
      this.states = this.countries[10].states
      this.selectedState = this.states[0]
    },
    changeCountry (event) {
      const selectedCountry = this.countries.find(country => country.value === event.target.value)
      const stateSelectContainer = document.querySelector('#appointmentState + label + .select-selected + .select-items')
      const stateSelectLabel = document.querySelector('#appointmentState + label + .select-selected')
      this.selectedCountry = event.target.value
      document.querySelector('#appointmentCountry').value = event.target.value
      document.querySelector('#appointmentCountry + label + .select-selected').innerHTML = selectedCountry.country
      this.states = selectedCountry.states
      this.selectedState = this.states[0]

      stateSelectLabel.innerHTML = this.selectedState
      stateSelectContainer.innerHTML = ''

      this.states.forEach(state => {
        const stateOption = document.createElement('div')
        stateOption.textContent = state

        stateOption.addEventListener('click', (e) => {
          const elements = document.querySelectorAll('#appointmentState + label + .select-selected + .select-items > div')

          elements.forEach(element => {
            element.removeAttribute('class')
          })

          this.selectedState = e.target.innerHTML
          stateSelectLabel.innerHTML = this.selectedState
          e.target.classList.add('same-as-selected')
          stateSelectContainer.classList.toggle('select-hide')
          document.querySelector('#appointmentState').value = this.selectedState
        })
        stateSelectContainer.appendChild(stateOption)
      })
    },
    isValid (validationType) {
      const errorSpans = document.querySelectorAll('span.errors')
      let isValid = true
      const requiredFields = document.querySelectorAll('.required')

      errorSpans.forEach(span => {
        span.parentNode.classList.remove('floating-input--error')
        span.parentNode.removeChild(span)
      })

      requiredFields.forEach(field => {
        if (field.closest('form#ProductAppointmentForm') && (field.tagName === 'INPUT' || field.tagName === 'TEXTAREA')) {
          const inputType = field.type

          if (this.isEmpty(field.value)) {
            this.addErrorStyling(field, this.emptyField)
            isValid = false
          } else if (inputType === 'email' && !this.validateEmail(field.value)) {
            this.addErrorStyling(field, this.invalidEmail)
            isValid = false
          } else if (inputType === 'tel' && !this.validatePhone(field.value)) {
            this.addErrorStyling(field, this.invalidPhone)
            isValid = false
          }
        }
      })

      return isValid
    },
    validateEmail (fieldValue) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      return emailRegex.test(fieldValue)
    },
    isEmpty (fieldValue) {
      return fieldValue === null || typeof fieldValue === 'undefined' || fieldValue.trim() === ''
    },
    validatePhone (fieldValue) {
      const phoneReg = /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/
      return phoneReg.test(fieldValue)
    },
    addErrorStyling (field, message) {
      const errorMessageElement = document.createElement('span')
      const labelForField = document.querySelector(`label[for="${field.id}"]`)

      errorMessageElement.classList.add('errors')
      errorMessageElement.textContent = message

      if (labelForField) {
        labelForField.parentNode.insertBefore(errorMessageElement, labelForField.nextSibling)
      } else {
        field.parentNode.insertBefore(errorMessageElement, field.nextSibling)
      }

      field.parentNode.classList.add('floating-input--error')
    },
    async submitForm (form, formType) {
      const formContainer = document.querySelector('.form-container.appointment')
      const successMessage = document.querySelector('.success-message.appointment')
      const formElement = document.querySelector('.form-container.appointment > form')

      if (!formContainer.classList.contains('submitted')) {
        formContainer.classList.add('submitted')

        const formData = new FormData(form)
        const entries = formData.entries()
        const data = Object.fromEntries(entries)
        const name = data.appointmentName.split(' ')
        const lastName = name[name.length - 1]
        const firstName = name.slice(0, -1).join(' ')
        let email = data.appointmentEmail
        let phone = data.appointmentPhone
        const message = data.appointmentMessage

        if (email.indexOf('+') !== -1) {
          email = email.replace(/\+/g, '%2B')
        }

        if (phone.indexOf('+') !== -1) {
          phone = phone.replace(/\+/g, '%2B')
        }

        const url = `https://suite54-cdnnet.emarsys.net/u/register.php?CID=${this.clientId}&f=${this.formId}&p=2&a=r&SID=&el=&llid=&counted=&c=&inp_1=${firstName}&inp_2=${lastName}&inp_3=${email}&inp_15=${phone}&inp_13=${data.appointmentPostcode}&inp_12=${data.appointmentState}&inp_14=${data.appointmentCountry}&${this.messageAccessCheckId}=${encodeURIComponent(message)}&msg=${encodeURIComponent(message)}`
        await fetch(url, { mode: 'no-cors' })
          .then(data => {
          // Handle successful response data here
            console.log('Success:', data)

            successMessage.classList.remove('hidden')
            formElement.classList.add('hidden')
            document.querySelector('.appointment__popup').classList.add('submitted')
          })
          .catch(error => {
          // Handle errors here
            console.error('Error:', error)
          })
      }
    }
  }
}
